import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';
import { colorPrimary } from '../../theme';

interface ToggleButtonProps {
	collapsed?: boolean;
}

export const Container = styled.div``;

export const TitleContainer = styled.div`
	display: grid;
	column-gap: 64px;
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.grey};
	padding-bottom: 16px;
	grid-template-columns: max-content auto max-content;

	& h1 {
		${({ theme }) => theme.typography.headlines.h5};
		justify-self: start;
	}

	& .desktop-title {
		display: inline;
	}
	
	@media (max-width: 549px) {
	grid-template-columns: max-content auto !important;
		
}

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		column-gap: 0;
		row-gap: 16px;

		& .desktop-title {
			display: none;
		}

		& h1 {
			justify-self: start;
			grid-row: 1;
			grid-column: 1;
		}

		& form {
			grid-row: 2;
			grid-column: 1 / 3;
		}

		& a {
			justify-self: end;
			grid-row: 1;
			grid-column: 2;
		}
	}
`;

export const ButtonsWrapper = styled.div`
	padding: 16px 0 0;
	display: flex;
	justify-content: start;
	gap: 24px;
`;

export const Label = styled.span`
	align-content: end;
`;

export const Field = styled.span``;

export const Form = styled.div`
	display: grid;
	grid-auto-rows: 24px minmax(50px, auto);
	padding: 16px 0;
	gap: 8px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		grid-auto-rows: minmax(50px, auto);
		grid-template-columns: 200px 1fr;
		gap: 12px;

		${Label} {
			align-content: center;
			grid-column: 1;
		}

		${Field} {
			grid-column: 2;
		}
	}
`;

export const FullLine = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const OneColumn = styled.div``;

export const FormFilter = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 20px;
	margin-top: 15px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		grid-template-columns: repeat(3, 1fr);

		${FullLine} {
			grid-column: 1 / -1;
		}

		${OneColumn} {
			grid-column: span 1;
		}
	}
`;

export const RelateDealership = styled.div`
	width: 100%;
	display: inline-flex;
	gap: 8px;
`;

export const EmptyRelatedDealerships = styled.div`
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
`;

export const ActionsContainer = styled.div`
	display: flex;
	gap: 4px;
`;

export const Dashboard = styled.div`
	display: flex;
	gap: 24px;
	margin-bottom: 32px;

	@media (max-width: ${DESKTOP_BREAKPOINT}px) {
		flex-direction: column;
	}
`;

export const TableWrapper = styled.div`
	overflow-x: auto;
`;

export const TagsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const NoData = styled.div`
	text-align: center;
	padding: 50px;
`;

export const ContainerCollapsed = styled.section<ToggleButtonProps>`
	display: flex;
	position: relative;
	${({ collapsed }) => (collapsed ? '' :'gap: 24px;')};
	padding: 32px 16px;
	margin: auto;
	max-width: 1200px;
	width: 100%;
	flex-direction: column;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		flex-direction: row;
	}
`;

export const ProfileAside = styled.aside<ToggleButtonProps>`
	background-color: ${({ theme }) => theme.colors.neutral.white};
	display: flex;
	flex-direction: column;
	width: 100%;
	${({ collapsed }) => (collapsed ? '' : 'padding: 16px')};
	border-radius: 12px;
	height: fit-content;
	transition: all 0.5s;
	position: relative;
	margin:10px 0px;

	&::after {
		display: ${({ collapsed }) => (collapsed ? 'block' : 'none')};
		text-align: center;
	}

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		width: 276px;
	}
`;

export const ToggleButton = styled.button<ToggleButtonProps>`
	display: block;
	position: absolute;
	cursor: pointer;
	top: 6px;
	left: 16px;
	background: none;
	border: none;
	font-size: 12px;
	background-color: ${colorPrimary};
    color: white;
    padding: 2px;
    border-radius: 4px;
`;

export const ProfilePages = styled.nav`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const PageContent = styled.div<ToggleButtonProps>`
	display: flex;
	flex: ${({ collapsed }) => (collapsed ? '1 0 100%' : '1')};
	flex-direction: column;
	transition: all 0.5s;
	margin:10px 0px
`;

export const SearchContainer = styled.div`
	position: relative;
	width: 100%;
	max-width: 400px;
`;

export const ClearButton = styled.button`
	position: absolute;
	right: 15px;
	top: 53%;
	transform: translateY(-50%);
	border: none;
	background: none;
	cursor: pointer;
	font-size: 16px;
	color: red;
`;

export const HelperText = styled.div`
	font-size: 10px;
`;